import { render, staticRenderFns } from "./AilmentAdd.vue?vue&type=template&id=7cdba98d"
import script from "./AilmentAdd.vue?vue&type=script&lang=js"
export * from "./AilmentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports